// Core Modules
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

// Services
import { ToastService } from '@core/services/toast/toast.service';

// Models
import { ToastModel } from '@shared/models/toast.model';

@Component({
  selector: 'app-toast',
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  // Injectors
  private readonly toastService = inject(ToastService);

  // Public Members
  public readonly toasts = this.toastService.toasts;
  public readonly variantClassMap: Record<ToastModel['variant'], string> = {
    error: 'alert-danger app-toast-variant-error',
    info: 'alert-info app-toast-variant-info',
    success: 'alert-success app-toast-variant-success',
    warning: 'alert-warning app-toast-variant-warning',
  };

  public dismiss(id: number): void {
    this.toastService.dismiss(id);
  }
}
